import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PageHero } from "@/components/common/SectionHeading";
import { lookupApplication } from "@/lib/lnlApi";
import { STATUS_TONE } from "@/lib/lnlConstants";

export default function ApplicationStatus() {
    const [ref, setRef] = useState("");
    const [email, setEmail] = useState("");
    const [doc, setDoc] = useState(null);
    const [err, setErr] = useState("");

    async function submit(e) {
        e.preventDefault();
        setErr(""); setDoc(null);
        try { setDoc(await lookupApplication(ref.trim(), email.trim())); }
        catch (x) { setErr(x?.response?.data?.detail || "Application not found."); }
    }

    return (
        <div data-testid="status-page">
            <PageHero
                eyebrow="Application status"
                title="Check your application status"
                description="Enter your reference number and the email address you used to apply."
                breadcrumbs={[{ label: "Home", to: "/" }, { label: "Admissions", to: "/admissions" }, { label: "Status" }]}
            />
            <section className="py-10 bg-white">
                <div className="lnl-container max-w-2xl">
                    <form onSubmit={submit} className="lnl-card p-6 grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="status-form">
                        <div>
                            <label className="text-xs text-lnl-gray font-heading font-semibold">Reference number</label>
                            <input value={ref} onChange={(e) => setRef(e.target.value)} placeholder="APP-2026-XXXXX" className="mt-1 w-full rounded-md border border-lnl-border px-3 py-2.5" data-testid="status-ref" required />
                        </div>
                        <div>
                            <label className="text-xs text-lnl-gray font-heading font-semibold">Contact email</label>
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-md border border-lnl-border px-3 py-2.5" data-testid="status-email" required />
                        </div>
                        <div className="sm:col-span-2">
                            <button className="lnl-btn-primary" data-testid="status-submit">Check status</button>
                        </div>
                    </form>
                    {err && <div className="mt-4 text-sm bg-rose-50 text-rose-800 border border-rose-200 rounded-md px-3 py-2">{err}</div>}
                    {doc && (
                        <div className="mt-6 lnl-card p-5" data-testid="status-result">
                            <div className="flex items-center justify-between">
                                <div className="font-heading font-bold">{doc.reference}</div>
                                <span className={`text-xs px-2 py-1 rounded-md border ${STATUS_TONE[doc.status] || ""}`} data-testid="status-badge">{doc.status}</span>
                            </div>
                            <div className="mt-2 text-sm text-lnl-gray">Applicant type: {doc.applicant_type} · Created {new Date(doc.created_at).toLocaleString()}</div>
                            <div className="mt-4 text-sm">
                                Documents uploaded: {doc.documents?.length || 0}
                            </div>
                            <div className="mt-4"><Link to={`/applicant/${doc.reference}?email=${encodeURIComponent(email)}`} className="lnl-btn-secondary">Open applicant dashboard</Link></div>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}
